<template>
	<div id='tagter'>
		<tyc :tqobj='tqobj'></tyc>
		<span v-show="tagobj.type == 'terSt'">
			<el-tag :type="terType[tagobj.vl]" size="mini">{{terSt[tagobj.vl]}}</el-tag>
		</span>
		<span v-show="tagobj.type == 'nterSt'">
			<el-tag :type="nterType[tagobj.vl]" size="mini">{{nterSt[tagobj.vl]}}</el-tag>
		</span>
		<span v-show="tagobj.type == 'openAuthType'">
			<el-tag :type="openAuthType[tagobj.vl]" size="mini">{{openAuthSt[tagobj.vl]}}</el-tag>
		</span>
	</div>
</template>

<style>
	#tagter {
		display: inline;
	}
</style>

<script>
	import tyc from './tyc'
	export default {
		components: {
			tyc
		},
		data() {
			return {
				tqobj: '',
				terSt: '', // 终端状态
				terType: {
					'0': 'gray',
					'1': 'success',
					'2': 'danger',
					'3': 'warning',
					'4': 'danger'
				},
				nterSt: '', // 非智终端
				nterType: {
					'0': 'gray',
					'1': 'success',
				},
				openAuthSt: '', // 开放平台授权
				openAuthType: {
					'0': 'success',
					'1': 'danger',
				},
			}
		},
		props: [
			'tagobj'
		],
		watch: {
			/**推荐 */
			tagobj() {
				// this.tagobj.type
				// this.tagobj.vl
			}
		},
		computed: {

		},
		methods: {

		},
		mounted() {
			this.tqobj = {
				keys: ['terminalType', 'nonTerType', 'openplAuth'],
				callback: (data) => {
					this.terSt = data[0]
					this.nterSt = data[1]
					this.openAuthSt = data[2]
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// tagc.vue?3868da99